<template>
  <div
    class="align-center background-color-white d-flex flex-column full-width pb-5 pt-7 px-7"
  >
    <div class="font-size-lg-res font-weight-semibold mb-4 text-center">
      Phone Number Confirmation
    </div>
    <AuthElementsEnterCode :phone="identification.phone" />
    <v-form ref="form" v-model="valid" @submit.prevent="fetchAccountStatus">
      <SMSInput :code="code" :updateCode="updateCode" />
      <AuthElementsSMSResend
        :phone="identification.phone"
        :resent="resetForm"
      />
      <AuthElementsSMSError />
      <v-btn
        color="success"
        :disabled="!valid"
        type="submit"
        block
        large
        rounded
      >
        <div class="font-size-md font-weight-semibold text-capitalize">
          submit
        </div>
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
// import { formatPhoneNumberForApi } from "@/util.js";
import { Steps } from "@/types/signup.js";
import AuthElementsEnterCode from "@/components/Auth/Elements/EnterCode.vue";
import AuthElementsSMSError from "@/components/Auth/Elements/SMSError.vue";
import AuthElementsSMSResend from "@/components/Auth/Elements/SMSResend.vue";
import SMSInput from "@/components/Inputs/SMS.vue";

export default {
  name: "SignUpConfirmationContent",
  components: {
    AuthElementsEnterCode,
    AuthElementsSMSError,
    AuthElementsSMSResend,
    SMSInput,
  },
  computed: {
    ...mapGetters({
      authorized: "auth/isAuthenticated",
    }),
    ...mapState({
      account: (state) => state.auth.account,
      showSMSRetryMessage: (state) => state.auth.showSMSRetryMessage,
      user: (state) => state.user.info,
    }),
  },
  data() {
    return {
      valid: true,
    };
  },
  methods: {
    async fetchAccountStatus() {
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      this.$store.commit("auth/SHOW_SMS_RETRY_MESSAGE", false);
      const { input0, input1, input2, input3 } = this.code;
      const verificationCode = input0.concat(input1, input2, input3);

      const info = {
        country_code: 1,
        phone: this.identification.phone,
        verification_code: verificationCode,
      };
      await this.$store.dispatch("auth/fetchAccountStatus", info);

      if (this.showSMSRetryMessage) {
        return;
      }

      if (this.authorized && !this.user.phone) {
        this.$store.dispatch("user/update", {
          name: `${this.identification.firstName} ${this.identification.lastName}`,
          phone: this.identification.phone,
        });
      }
      // this.authorized ? this.fetchCart() : this.toRegistration();
      this.authorized && !this.account
        ? this.fetchCart()
        : this.toRegistration();
    },
    toRegistration() {
      this.to
        ? this.to(Steps.registration)
        : this.$router.push({ name: Steps.registration });
    },
    resetForm() {
      [0, 1, 2, 3].forEach((idx) => this.updateCode(idx, null));
      this.$refs.form.resetValidation();
    },
  },
  props: {
    code: Object,
    fetchCart: Function,
    identification: Object,
    to: Function,
    updateCode: Function,
  },
};
</script>
